import { Routes } from '@angular/router';
import { LayoutComponent } from './main/modules/layout/layout.component';
import { AuthLayoutComponent } from './main/modules/auth-layout/auth-layout.component';
import { LoginComponent } from './main/auth/login/login.component';
import { ResetPasswordComponent } from './main/auth/reset-password/reset-password.component';
import { ChangePasswordComponent } from './main/auth/change-password/change-password.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./main/modules/layout/home-routing.module').then(m => m.HomeRoutingModule)
      }
    ]
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: 'change-password', component: ChangePasswordComponent }
    ]
  },
  { path: '**', redirectTo: 'home' }
];
